import React, { useState, useEffect } from "react";
import Common_heading from "../common/common_heading/Common_heading";
import Career_banner from "./career_banner/Career_banner";
import Full_screen_modal from "../common/full_screen_modal/Full_screen_modal";
import { Success_lottie } from "../common/lotties/success_lottie/Success_lottie";
import CareerBenefitsForm from "./careerBenefitsForm/CareerBenefitsForm";
import JobOpenings from "./jobOpenings/JobOpenings";
import { AllCareer } from "../../utils/apis/career/career";
import { useForm } from "react-hook-form";

function Career() {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [career, setCareer] = useState([]);


  // Auto-close success screen after 2 seconds
  useEffect(() => {
    if (showSuccessModal) {
      const timer = setTimeout(() => {
        setShowSuccessModal(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [showSuccessModal]);

  const getAllCareer = async () => {
    const res = await AllCareer();
    if (res?.success) {
      setCareer(res.data || []);
    }
  };

  useEffect(() => {
    getAllCareer();
  }, []);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    control,
    watch,
    formState: { errors },
  } = useForm({});


  return (
    <>
      <section className="career-section">
        {/* Banner */}
        <div>
          <Career_banner />
        </div>

        <div className="container">
          {/* Heading */}
          <div>
            <Common_heading
              title="Explore Exciting Career Opportunities with Us"
              subtitle="Join our dynamic team and be part of a company that values innovation, growth, and making a positive impact in the industry. Discover your potential and build a rewarding career with us."
            />
          </div>

          {/* Career Form */}
          <div id="apply-now-form">
            <CareerBenefitsForm
              onApplicationSuccess={() => setShowSuccessModal(true)}
              register={register}
              handleSubmit={handleSubmit}
              reset={reset}
              setValue={setValue}
              getValues={getValues}
              control={control}
              errors={errors}
              watch={watch}
            />
          </div>

          {/* Job Openings */}
          <div>
            <JobOpenings career={career} setValue={setValue} />
          </div>
        </div>
      </section>

      {/* Success Modal */}
      <Full_screen_modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        lottie={<Success_lottie />}
      />
    </>
  );
}

export default Career;
